import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Button } from 'react-bootstrap';
import { handleBrowserBack } from '../../BrowserBack';
import Heading from '../../molecules/Heading';
import StepNavigation from '../../molecules/StepNavigation';
import { usage_pattern_type } from '../../Const';

const MypageOpeningComplete: React.FC = () => {
  const [disabled, setDisabled] = useState(true);
  const [complete_body, setCompleteBody] = useState('');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();

    // URLパラメータを取得する
    const search_params = new URLSearchParams(document.location.search.substring(1));
    // usage_patternが1なら上部見出しとステップナビゲーションを表示する
    if (search_params.get('usage_pattern') === usage_pattern_type.from_preliminary_review) {
      setDisabled(false);
    }

    // 開設完了本文を取得する
    const node = document.getElementById('mypage-complete-body');
    setCompleteBody(node?.innerHTML as string);
  }, []);

  /**
   * 戻るボタン
   */
  const handleClickBack = () => {
    location.replace(sessionStorage.getItem('mypage_entry_url') ?? document.referrer);
  };

  /**
   * dangerouslySetInnerHTMLにセットするためのオブジェクト
   * @returns object
   */
  const createCompleteBody = () => {
    return { __html: complete_body };
  };

  return (
    <>
      <Heading
        label="借入申込事前準備"
        size="l"
        css_class={`${disabled ? 'p-step-disabled' : ''}`}
      />
      <StepNavigation
        step1="事前審査結果確認"
        step2="マイページ開設"
        step3="完了"
        current={3}
        disabled={disabled}
      />
      <div className="p-authentication mx-auto col-11">
        <div className="heading-m">マイページ開設完了</div>
        <div dangerouslySetInnerHTML={createCompleteBody()}></div>

        <div className="p-back-btn-box">
          <Button
            variant="custom"
            className="btn-large btn-white arrow-left-small"
            size="lg"
            onClick={handleClickBack}
          >
            戻る
          </Button>
        </div>
      </div>
    </>
  );
};

if (document.getElementById('mypage-opening-complete')) {
  render(<MypageOpeningComplete />, document.getElementById('mypage-opening-complete'));
}
